import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useScreenInit } from './useScreenInit.js';
import { Header } from './components/Header';
import { WelcomeScreen } from './components/WelcomeScreen';
import { QuestionScreen, Option } from './components/QuestionScreen';
import { ResultsScreen } from './components/ResultsScreen';
import { AnalyzingScreen } from './components/AnalyzingScreen';
const QUIZ_DATA = [{
  id: 1,
  progress: 20,
  progressLabel: 'Pregunta 1 de 5',
  question: '¿Cuál es tu nivel actual en el mundo de la pastelería?',
  options: [{
    id: '1a',
    emoji: '🙋',
    text: 'No sé ni prender el horno, ¡pero tengo muchas ganas de aprender!'
  }, {
    id: '1b',
    emoji: '🏠',
    text: 'Hago cosas ricas para mi familia, pero nunca vendí nada.'
  }, {
    id: '1c',
    emoji: '💼',
    text: 'Ya emprendo en gastronomía pero busco algo más rentable y fácil.'
  }]
}, {
  id: 2,
  progress: 40,
  progressLabel: 'Pregunta 2 de 5',
  question: '¿Qué es lo que más te atrae de emprender con Minidonas?',
  options: [{
    id: '2a',
    emoji: '💰',
    text: 'La baja inversión inicial (puedo arrancar con lo que tengo en casa).'
  }, {
    id: '2b',
    emoji: '📱',
    text: 'Que se venden solos por Instagram y WhatsApp sin local físico.'
  }, {
    id: '2c',
    emoji: '🎂',
    text: 'La posibilidad de hacer catering y torres temáticas para eventos.'
  }]
}, {
  id: 3,
  progress: 60,
  progressLabel: 'Pregunta 3 de 5',
  question: '¿Cuál creés que es tu mayor obstáculo para empezar hoy mismo?',
  options: [{
    id: '3a',
    emoji: '📊',
    text: 'No sé cómo calcular los costos para no perder plata.'
  }, {
    id: '3b',
    emoji: '🎨',
    text: 'Me da miedo que el glaseado o la masa no me queden profesionales.'
  }, {
    id: '3c',
    emoji: '👥',
    text: 'No sé cómo conseguir mis primeros clientes.'
  }]
}, {
  id: 4,
  progress: 80,
  progressLabel: 'Pregunta 4 de 5',
  question: 'Si pudieras elegir una especialidad, ¿cuál te gustaría dominar?',
  options: [{
    id: '4a',
    emoji: '🍩',
    text: 'Minidonas clásicas y coloridas para todo tipo de clientes.'
  }, {
    id: '4b',
    emoji: '🧂',
    text: 'Opciones saladas para picadas y eventos gourmet.'
  }, {
    id: '4c',
    emoji: '🎉',
    text: 'Torres y Tortas Temáticas (¡las pirámides que son tendencia ahora!).'
  }]
}, {
  id: 5,
  progress: 95,
  progressLabel: 'Pregunta 5 de 5 — ¡Última pregunta!',
  question: '¿Cuánto tiempo podrías dedicarle a tu emprendimiento por semana?',
  options: [{
    id: '5a',
    emoji: '⏰',
    text: 'Solo un par de horas los fines de semana por ahora.'
  }, {
    id: '5b',
    emoji: '🌙',
    text: 'Una o dos horas por día después del trabajo o las tareas del hogar.'
  }, {
    id: '5c',
    emoji: '🚀',
    text: 'Quiero que sea mi actividad principal y dedicarme full-time.'
  }]
}];
export function App() {
  const init = useScreenInit();
  const [step, setStep] = useState<number>(init.step ?? 0);
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const goNext = () => {
    window.scrollTo(0, 0);
    setStep(prev => Math.min(prev + 1, 7));
  };
  const handleSelectAndAdvance = (questionId: number, optionId: string) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: optionId
    }));
    // Brief delay so the selection state is visible before transitioning
    setTimeout(() => goNext(), 280);
  };
  let content;
  let headerData: {
    progress: number;
    label: string;
  } | null = null;
  if (step === 0) {
    content = <WelcomeScreen onNext={goNext} data-id="element-0" />;
  } else if (step >= 1 && step <= 5) {
    const q = QUIZ_DATA[step - 1];
    headerData = {
      progress: q.progress,
      label: q.progressLabel
    };
    content = <QuestionScreen question={q.question} options={q.options} selectedOptionId={answers[q.id]} onSelect={optionId => handleSelectAndAdvance(q.id, optionId)} data-id="element-1" />;
  } else if (step === 6) {
    content = <AnalyzingScreen onComplete={goNext} data-id="element-2" />;
  } else {
    content = <ResultsScreen data-id="element-3" />;
  }
  return <div className="min-h-screen bg-rose-50 flex justify-center" data-id="element-4">
      <div className="w-full max-w-md bg-[#fff7ed] shadow-2xl relative flex flex-col min-h-screen overflow-hidden" data-id="element-5">
        {step >= 1 && step <= 5 && headerData && <Header progress={headerData.progress} label={headerData.label} data-id="element-6" />}
        <main className="flex-grow flex flex-col relative" data-id="element-7">
          <AnimatePresence mode="wait" data-id="element-8">
            <motion.div key={step} initial={{
            opacity: 0,
            x: 40
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -40
          }} transition={{
            duration: 0.35,
            ease: [0.22, 1, 0.36, 1]
          }} className="flex-grow flex flex-col" data-id="element-9">
              {content}
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </div>;
}